import { GenerarFicheroModelo190CommandProps } from "api/Commands/GenerarFicheroModelo190Command"
import { PerceptorDeclaracionModelo190DtoProps } from "api/Commands/PerceptorDeclaracionModelo190Dto"
import { ClavePercepcionModelo190Type } from "api/Types/ClavePercepcionModelo190"

export interface PerceptorFormModel {
  anualidadesAlimento: number
  nacimientoPerceptor: number
  mayor75: number
  ascendientesPorEnteroTwo: number
  ascendientePorcentajeDiscapacidad: number
  ascendientesDiscPorEntero: number
  ascendientePorcentajeDiscapacidadDos: number
  ascendientesDiscPorEnteroThree: number
  ascendienteMolvilidadReducida: number
  ascendientesDiscPorEnteroTwo: number
  menor75: number
  ascendientesPorEntero: number
  ceutaMelilla: number
  clave: ClavePercepcionModelo190Type
  provincia: string | null
  complementoAyuda: number
  computiFirst: number
  computiSecond: number
  computiThird: number
  comunicacionPrestamo: number
  foralNavarra: number
  contratoORelacion: number
  foralAlava: number
  foralBiskaia: number
  foralGipuzkoa: number
  discapacidadPerceptor: number
  ejercicioDevengo: number
  excesoAcciones: number
  gastosDeducibles: number
  haciendaEstatal: number
  porcentajeDiscapacidad: number
  discapacidadPorEntero: number
  porcentajeDiscapacidadDos: number
  discapacidadPorEnteroThree: number
  molvilidadReducida: number
  discapacidadPorEnteroTwo: number
  menorTresAnos: number
  porEntero: number
  especieNoretencionesEfectuados: number
  especieretencionesEfectuados: number
  especieNoRepercutidos: number
  especieRepercutidos: number
  movilidadGeografica: number
  nifConyuge: string | null
  nif: string | null
  legalRepresentative: string | null
  denominacion: string | null
  pensiones: number
  percepcionesDinerariasNoDerivadasIncapacidadLaboral: {
    percepcionIntegra: number
    retencionPractica: number
  }
  dinerariaPercepcionIntegra: number
  reducciones: number
  resto: number
  porEnteroTwo: number
  rendimientosTrabajoEmprendimientoInnovacion: number
  dinerariaRetencionesPracticadas: number
  situacionFamiliar: number
  subclave: number
  tipoPrestacionClaveB01Incapacidad: number
  tipoPrestacionClaveB01Jubilacion: number
  tipoPrestacionClaveB01PensionesNoContributivas: number
  tipoPrestacionClaveB01Resto: number
  tipoPrestacionClaveB01Viudedad: number
  titularUnidadConvivencia: number
  especieValoracion: number
  especieNoValoracion: number
}
export interface DeclaranteFormModel {
  declaracionComplementaria?: boolean | null
  declaracionSustitutiva?: boolean | null
  email?: string | null
  importeTotalPercepciones?: number
  importeTotalRetenciones?: number
  nifDeclarante?: string | null
  nombre?: string | null
  numeroIdentificativoDeclaracionAnterior?: number
  numeroTotalPercepciones?: number
  personaContacto?: string | null
  selloElectronico: string | null
  telefono: number
}
export interface Modelo190FormModel {
  "01"?: number
  "02"?: number
  "03"?: number
  declarante: DeclaranteFormModel
  perceptores: PerceptorFormModel[]
  ejercicio: string | null
}
export const postModelo190Adapter = (
  formData: Modelo190FormModel
): GenerarFicheroModelo190CommandProps => {
  return {
    declaracionModelo190: {
      declarante: {
        declaracionComplementaria:
          formData?.declarante?.declaracionComplementaria ?? false,
        declaracionSustitutiva:
          formData?.declarante?.declaracionSustitutiva ?? false,
        email: formData?.declarante?.email ?? "",
        importeTotalPercepciones: formData?.["02"] ?? 0,
        importeTotalRetenciones: formData?.["03"] ?? 0,
        nifDeclarante: formData?.declarante?.nifDeclarante ?? "",
        nombre: formData?.declarante?.nombre ?? "",
        numeroIdentificativoDeclaracionAnterior:
          formData?.declarante?.numeroIdentificativoDeclaracionAnterior ?? 0,
        numeroTotalPercepciones: formData?.["01"] ?? 0,
        personaContacto: formData?.declarante?.personaContacto ?? "",
        selloElectronico: formData?.declarante?.selloElectronico,
        telefono: formData?.declarante?.telefono,
      },
      ejercicio: formData?.ejercicio,
      perceptores: formData?.perceptores?.map(
        (
          perceptor: PerceptorFormModel
        ): PerceptorDeclaracionModelo190DtoProps => ({
          anualidadesPorAlimentos: perceptor?.anualidadesAlimento,
          anyoNacimiento: perceptor?.nacimientoPerceptor,
          ascendientes75OMasNumeroTotal: perceptor?.mayor75,
          ascendientes75OMasPorEntero: perceptor?.ascendientesPorEnteroTwo,
          ascendientesConDiscapacidad33a65NumeroTotal:
            perceptor?.ascendientePorcentajeDiscapacidad,
          ascendientesConDiscapacidad33a65PorEntero:
            perceptor?.ascendientesDiscPorEntero,
          ascendientesConDiscapacidad65OMasNumeroTotal:
            perceptor?.ascendientePorcentajeDiscapacidadDos,
          ascendientesConDiscapacidad65OMasPorEntero:
            perceptor?.ascendientesDiscPorEnteroThree,
          ascendientesConMovilidadReducidaNumeroTotal:
            perceptor?.ascendienteMolvilidadReducida,
          ascendientesConMovilidadReducidaPorEntero:
            perceptor?.ascendientesDiscPorEnteroTwo,
          ascendientesMenoresDe75NumeroTotal: perceptor?.menor75,
          ascendientesMenoresDe75PorEntero: perceptor?.ascendientesPorEntero,
          ceutaMelilla: perceptor?.ceutaMelilla,
          clavePercepcion: perceptor?.clave,
          codigoProvincia: perceptor?.provincia,
          complementoAyudaParaInfancia: perceptor?.complementoAyuda,
          computoHijo1: perceptor?.computiFirst,
          computoHijo2: perceptor?.computiSecond,
          computoHijo3: perceptor?.computiThird,
          comunicacionPrestamosViviendaHabitual:
            perceptor?.comunicacionPrestamo,
          comunidadForalDeNavarra: perceptor?.foralNavarra,
          contratoORelacion: perceptor?.contratoORelacion,
          diputacionForalAlava: perceptor?.foralAlava,
          diputacionForalBizkaia: perceptor?.foralBiskaia,
          diputacionForalGipuzkoa: perceptor?.foralGipuzkoa,
          discapacidad: perceptor?.discapacidadPerceptor,
          ejercicioDevengo: perceptor?.ejercicioDevengo,
          excesosEntregaAccionesEmpresasEmergentes: perceptor?.excesoAcciones,
          gastosDeducibles: perceptor?.gastosDeducibles,
          haciendaEstatal: perceptor?.haciendaEstatal,
          descConDiscapacidad33a65NumeroTotal:
            perceptor?.porcentajeDiscapacidad,
          descConDiscapacidad33a65PorEntero: perceptor?.discapacidadPorEntero,
          descConDiscapacidad65OMasNumeroTotal:
            perceptor?.porcentajeDiscapacidadDos,
          descConDiscapacidad65OMasPorEntero:
            perceptor?.discapacidadPorEnteroThree,
          descConMovilidadReducidaNumeroTotal: perceptor?.molvilidadReducida,
          descConMovilidadReducidaPorEntero:
            perceptor?.discapacidadPorEnteroTwo,
          descendientesMenoresDe3AnyosNumeroTotal: perceptor?.menorTresAnos,
          descendientesMenoresDe3AnyosPorEntero: perceptor?.porEntero,
          ingresosCuentaEfectuadosPercepcionesEnEspecieNoDerivadas:
            perceptor?.especieNoretencionesEfectuados,
          ingresosCuentaEfectuadosPrestacionesEnEspecieDerivadas:
            perceptor?.especieretencionesEfectuados,
          ingresosCuentaRepercutidosPercepcionesEnEspecieNoDerivadas:
            perceptor?.especieNoRepercutidos,
          ingresosCuentaRepercutidosPrestacionesEnEspecieDerivadas:
            perceptor?.especieRepercutidos,
          movilidadGeografica: perceptor?.movilidadGeografica,
          nifConyugeOTitular: perceptor?.nifConyuge,
          nifPerceptor: perceptor?.nif,
          nifRepresentanteLegal: perceptor?.legalRepresentative,
          nombrePerceptor: perceptor?.denominacion,
          pensionesCompensatorias: perceptor?.pensiones,
          percepcionesDinerariasNoDerivadas:
            perceptor?.percepcionesDinerariasNoDerivadasIncapacidadLaboral
              ?.percepcionIntegra,
          percepcionIntegraDinerariasDerivadas:
            perceptor?.dinerariaPercepcionIntegra,
          reduccionesAplicables: perceptor?.reducciones,
          rendimientosTrabajoEmprendimientoInnovacion:
            perceptor?.rendimientosTrabajoEmprendimientoInnovacion,
          restoDescendientesNumeroTotal: perceptor?.resto,
          restoDescendientesPorEntero: perceptor?.porEnteroTwo,
          retencionesPracticadasDinerariasNoDerivadas:
            perceptor?.percepcionesDinerariasNoDerivadasIncapacidadLaboral
              ?.retencionPractica,
          retencionesPracticadasPrestacionesDerivadas:
            perceptor?.dinerariaRetencionesPracticadas,
          situacionFamiliar: perceptor?.situacionFamiliar,
          subclave: perceptor?.subclave,
          tipoPrestacionClaveB01Incapacidad:
            perceptor?.tipoPrestacionClaveB01Incapacidad,
          tipoPrestacionClaveB01Jubilacion:
            perceptor?.tipoPrestacionClaveB01Jubilacion,
          tipoPrestacionClaveB01PensionesNoContributivas:
            perceptor?.tipoPrestacionClaveB01PensionesNoContributivas,
          tipoPrestacionClaveB01Resto: perceptor?.tipoPrestacionClaveB01Resto,
          tipoPrestacionClaveB01Viudedad:
            perceptor?.tipoPrestacionClaveB01Viudedad,
          titularUnidadConvivencia: perceptor?.titularUnidadConvivencia,
          valoracionPercepcionesEnEspecieDerivadas:
            perceptor?.especieValoracion,
          valoracionPercepcionesEnEspecieNoDerivadas:
            perceptor?.especieNoValoracion,
        })
      ),
    },
  }
}
